export const creditCardContentBox = {
    showLockAndUnlockNavigation: true,
    showDisplayPinNavigation: true,
    showPayUpNavigation: true,
};
